export const CallHistoryAction = ({ history }) => ({
  type: 'nuxiba_callHistory',
  history
})

